import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.data.queries.integrations.useRefreshNetSuiteCache', {
    successMessages: 'Cache sync is in progress.',
});
